export default __webpack_public_path__ + "static/media/logo.527c80a6.png";